<style lang="scss">


@media screen and (min-width: 55rem) {
  .CloudPictureContent {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-height: 50rem;
    position: relative;

    .content-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 100%;
      min-height: 35rem;
      margin-top: -2.5rem;

      .content-left {
        width: 60%;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .content-left-container {
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          img {
            display: block;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
          }
          video {
            display: block;
            width: 80%;
            height: 80%;
            min-height: 20rem;
          }
        }
      }

      .content-right {
        width: 40%;
        min-height: 35rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .right-top {
          font-family:  'PingFang SC','Microsoft YaHei';
          font-size: 2rem;
          margin-bottom: 3rem;
        }
        .right-bottom {
          font-family:  'PingFang SC','Microsoft YaHei';
          font-size: 1.6rem;
        }
      }
    }
    .CloudPictureContent-list {
      width: 100%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: center !important;
      .vue-waterfall-easy-container {
        width: 100% !important;
        .vue-waterfall-easy-scroll {
          overflow-y: scroll !important;
        }
      }

      .img-info {
        width: 250px;
        height: 4.5rem;
        background: rgba(0, 0, 0, 0.245);
        float: right;
        position: absolute;
        bottom: 0.8rem;
        // border-radius: 2rem;
        // overflow: hidden;
        display: flex;
        flex-direction: row;
        justify-content: center;
        .img-title {
          width: 92%;
          text-align: left;
          font-family:  'PingFang SC','Microsoft YaHei';
          color: #fff;
          font-size: 1.4rem;
        }
        .img-content {
          // text-align: left;
          // font-family:  'PingFang SC','Microsoft YaHei';
          // color: #fff;
          // font-size: 1.2rem;
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .CloudPictureContent {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    min-height: 50rem;
    position: relative;
    .content-container {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      min-height: 27rem;

      .content-left {
        width: 100%;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .content-left-container {
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          img {
            display: block;
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
          }
          video {
            display: block;
            width: 80%;
            height: 80%;
            min-height: 20rem;
          }
        }
      }

      .content-right {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 3rem;

        .right-top {
          font-family:  'PingFang SC','Microsoft YaHei';
          font-size: 2rem;
          margin-bottom: 3rem;
        }
        .right-bottom {
          font-family:  'PingFang SC','Microsoft YaHei';
          font-size: 1.6rem;
        }
      }
    }
    .CloudPictureContent-list {
      width: 100%;
      display: flex;
      // background-color: darkgoldenrod;

      .vue-waterfall-easy-container {
        width: 100% !important;
        .vue-waterfall-easy-scroll {
          overflow-y: scroll !important;

          .img-inner-box {
            .img-info {
              width: 250px;
              height: 4.5rem;
              background: rgba(0, 0, 0, 0.245);
              float: right;
              position: absolute;
              bottom: 0.8rem;
              // border-radius: 2rem;
              // overflow: hidden;
              display: flex;
              flex-direction: row;
              justify-content: center;
              .img-title {
                width: 92%;
                height: 4.5rem;
                max-height: 4.5rem;
                text-align: left;
                font-family:  'PingFang SC','Microsoft YaHei';
                color: #fff;
                font-size: 1.4rem;
                overflow: hidden;
              }
              .img-content {
                // text-align: left;
                // font-family:  'PingFang SC','Microsoft YaHei';
                // color: #fff;
                // font-size: 1.2rem;
                display: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="CloudPictureContent">
    <el-dialog
      :visible.sync="this.openDialog"
      width="80%"
      :before-close="closeDialog"
    >
      <div class="content-container">
        <div class="content-left">
          <div class="content-left-container">
            <img
              v-if="
                !this.selectConfig.video_url ||
                this.selectConfig.video_url == ''
              "
              :src="this.selectConfig.src"
            />
            <video
              v-else
              :src="this.selectConfig.video_url"
              controls="controls"
              class="video"
            ></video>
          </div>
        </div>
        <div class="content-right">
          <div class="right-top">
            {{ this.selectConfig.title }}
          </div>

          <div class="right-bottom">
            {{ this.selectConfig.content }}
          </div>
        </div>
      </div>
    </el-dialog>

    <div class="CloudPictureContent-list">
      <vue-waterfall-easy
        :maxCols="4"
        :imgsArr="imgsArr"
        :imgWidth="250"
        @scrollReachBottom="getData"
        @click="clickFn"
      >
        <div class="img-info" slot-scope="props">
          <p class="img-title">{{ props.value.title }}</p>
          <p class="img-content">{{ props.value.content }}</p>
        </div>
      </vue-waterfall-easy>
    </div>
  </div>
</template>

<script>
import vueWaterfallEasy from "vue-waterfall-easy";
import { fetchPicture } from "@/yintai/api/picture";

export default {
  name: "CloudPictureContent",
  components: {
    vueWaterfallEasy,
  },
  data() {
    return {
      imgsArr: [],
      imageList: [],
      group: 0, // request param
      openDialog: false,
      selectConfig: {
        video_url: "",
        url: "",
      },
      screenWidth: undefined,
      maxCols: 5,
      hasMore: true,
    };
  },
  mounted() {
    this.getData();
    this.group = 1;

    const that = this;

    window.screenWidth = document.body.clientWidth;
    let screenWidth = window.screenWidth;
    let cols = Math.floor(screenWidth / 250);
    if (cols <= 1) {
      cols = 1;
    }
    if (cols >= 5) {
      cols = 5;
    }
    that.maxCols = "5";

    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          // 打印screenWidth变化的值
          console.log(that.screenWidth);
          that.timer = false;
          let cols = Math.floor(that.screenWidth / 250);
          if (cols <= 1) {
            cols = 1;
          }
          if (cols >= 5) {
            cols = 5;
          }
          that.maxCols = cols;
          console.log(that.maxCols);
        }, 400);
      }
    },
  },
  methods: {
    async getData() {
      if (this.hasMore) {
        const result = await fetchPicture({ page: this.group });
        let imageTempList = result.data.data.data;
        console.log(imageTempList);
        for (let i = 0; i < imageTempList.length; i++) {
          this.imageList.push({
            src: imageTempList[i].url,
            title: imageTempList[i].title,
            content: imageTempList[i].content,
            href: imageTempList[i].href,
            video_url: imageTempList[i].video_url,
          });
        }
        if (imageTempList.length == 15) {
          this.group++;
        } else {
          this.hasMore = false;
        }
        this.imgsArr = this.imgsArr.concat(this.imageList);
        this.imageList = [];
      } else {
        return;
      }
    },

    clickFn(event, { index, value }) {
      // 阻止a标签跳转
      event.preventDefault();
      this.selectConfig = value;
      this.openDialog = true;

      if (event.target.tagName.toLowerCase() == "img") {
        console.log("img clicked", index, value);
      }
    },
    closeDialog() {
      this.openDialog = false;
      this.selectConfig = {
        video_url: "",
        url: "",
      };
    },
  },
};
</script>
